import { render, staticRenderFns } from "./MutateOwnerReportModal.vue?vue&type=template&id=312a30b8"
import script from "./MutateOwnerReportModal.vue?vue&type=script&lang=ts"
export * from "./MutateOwnerReportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZBreadcrumbItem: require('/app/components/zeal/ZBreadcrumb/ZBreadcrumbItem/ZBreadcrumbItem.vue').default,ZBreadcrumb: require('/app/components/zeal/ZBreadcrumb/ZBreadcrumb.vue').default,ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,CopyButton: require('/app/components/CopyButton.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ToggleInput: require('/app/components/Form/ToggleInput.vue').default,ZCheckbox: require('/app/components/zeal/ZCheckbox/ZCheckbox.vue').default,ZRadio: require('/app/components/zeal/ZRadio/ZRadio.vue').default,ZRadioGroup: require('/app/components/zeal/ZRadioGroup/ZRadioGroup.vue').default,SelectRepositoriesForReport: require('/app/components/Reports/SelectRepositoriesForReport.vue').default,ZModal: require('/app/components/zeal/ZModal/ZModal.vue').default})
